import React from "react";

export default class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-6 align-self-center">
              <div className="social mb-3">
                <a
                  href="https://www.facebook.com/instituteonstatelessnessinclusion/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/images/facebook.png"
                    className="social-btn"
                    alt="facebook"
                  />
                </a>
                <a
                  href="https://twitter.com/institute_si"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/images/twitter.png"
                    className="social-btn ml-2"
                    alt="twitter"
                  />
                </a>
              </div>
              <div className="logo">
                <img src="/images/logo.png" className="logo" alt="logo" />
              </div>
            </div>
            <div className="col-6 align-self-center">
              <div className="buttons text-right">
                <div>
                  <a
                    href="mailto:info@institutesi.org"
                    className="btn btn-default pt-1 pb-1 mb-2"
                  >
                    Contact
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.geef.nl/en/donate?charity=8695&type=e"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-default pt-1 pb-1"
                  >
                    ♥ Donate
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-12 text-center"
              style={{ alignSelf: "flex-end" }}
            >
              <p className="mb-0 privacy-policy">
                copyright © 2019 |{" "}
                <a
                  href="http://www.institutesi.org/PrivacyStatement.pdf"
                  target="_blank"
                  className="text-white"
                  rel="noopener noreferrer"
                >
                  privacy statement
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js